module.exports = "/images/call2pay.png?2e0b136eadc7795625419e176925a2c4";